import AboutSection from "./AboutSection";
// import AmenitiesSection from "./AmenitiesSection";
import BlogSection from "./BlogSection";
import ExtraServices from "./ExtraService";
import Room from "./Rooms";
import ServicesSection from "./ServiceSection";
import SectionService from './SectionService';
import TestimonialSection from "./TestimonialSection";
import SlickSlider from "./SlickSlider";
import TeamSection from "./TeamSection";
import OmSaiPG from "./OmSaiPG";
import { Helmet } from "react-helmet";
import VideoSection from "./VideoSection";


export default function Home(){
    return(
        <>
        
          <Helmet>

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Om Sai PG",
      "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
      "url": "https://www.omsaipg.in",
      "logo": "https://www.omsaipg.in/logo.jpg",
      "image":"https://www.omsaipg.in/ogimage.jpg",
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+91 9763888448",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
        {
          "@type": "ContactPoint",
          "telephone": "+91 9922248255",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "bestRating": "5",
        "worstRating": "1",
        "ratingValue": "4.7",
        "ratingCount": "250",
      },
      "email": "omsaipgpune@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
        "addressLocality": "Kharadi",
        "addressRegion": "Maharashtra",
        "postalCode": "411014",
        "addressCountry": "IN",
      },
      "sameAs": [
        "https://www.facebook.com/omsaipg",
        "https://www.instagram.com/omsaipg",
        "https://www.linkedin.com/company/omsaipg"
      ],
      "priceRange": "INR 5000-15000",
      "paymentAccepted": "Cash, UPI, Credit Card",
      "telephone": "+91 9763888448",
      "email": "omsaipg@gmail.com",
      "keywords": [
        "PG in Pune",
        "PG in Kharadi",
        "PG with food in Pune",
        "PG for students in Kharadi",
        "PG for females in Pune",
        "PG for males in Pune",
        "Om Sai PG Kharadi",
        "Girls Hostels in Kharadi",
        "Boys Hostel in Kharadi",
        "Monthly Basis PG in Kharadi",
        "PG in Wagholi",
        "PG in Kharadi with food",
        "Hostels in Pune",
        "PG for Students in Kharadi Pune",
        "Paying Guest Hostel in Chandan Nagar"
      ],
      "openingHours": "Mo-Su 09:00-22:00"
    })}
  </script>

  {/* Title */}
  <title>
    Contact : +91 9763888448 / +91 9922248255 | Om Sai PG |Home| Hostel in Kharadi|Best PG Near Eon IT Park Kharadi | Om Sai PG Kharadi | Paying Guest in Kharadi
  </title>

  {/* Meta Tags */}
  <meta
    name="description"
    content="Om Sai PG offers the best PG accommodations in Kharadi, Pune. We provide PG for students, males, females, with food and other essential amenities."
  />
  <meta
    name="keywords"
    content="Hostel in Kharadi,PG in Kharadi,Best PG Near Eon IT Park Kharadi, Om Sai PG Kharadi, Paying Guest in Kharadi"
  />
  <meta name="robots" content="index, follow" />

  {/* Open Graph Tags */}
  <meta
    property="og:title"
    content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
  />
  <meta
    property="og:description"
    content="Looking for the best PG in Kharadi Pune? Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
  />
  <meta property="og:image" content="https://www.omsaipg.in/ogimage.jpg" />
  <meta property="og:url" content="https://www.omsaipg.in" />
  <meta property="og:type" content="website" />
</Helmet>
          <SlickSlider></SlickSlider>
          <AboutSection></AboutSection>
          <ServicesSection></ServicesSection>
          <Room></Room>
          <VideoSection></VideoSection>
          {/* <AmenitiesSection></AmenitiesSection> */}
          <ExtraServices></ExtraServices>
          <TestimonialSection></TestimonialSection>
          {/* <Testimonial></Testimonial> */}
          <BlogSection></BlogSection>
          <SectionService></SectionService>
          <OmSaiPG></OmSaiPG>
          <TeamSection></TeamSection>
         

        </>
    )    
}